import React from 'react';
import Button from '../../../../../../CustomizedAntDesign/Button';
import Chip from '../../../../../../Layout/Chip';

const LaravoActions = props => {
  const { loading, installed, onClick } = props;

  // Laravo's installed state comes from the API, so render nothing until it lands
  // rather than flashing an Install button at a merchant who already has a key.
  if (loading) {
    return null;
  }

  if (installed) {
    return <Chip data-testid="integrations__laravo--installed-chip">Installed</Chip>;
  }

  return (
    <Button type="primary" onClick={onClick} data-testid="integrations__laravo--install-button">
      Install
    </Button>
  );
};

export default LaravoActions;
